import { Link } from 'react-router-dom';
import useSeo from '@/hooks/useSeo';
import PageHero from '@/components/base/PageHero';

const values = [
  { icon: 'ri-search-eye-line', title: '清晰的浏览体验', desc: '多维筛选与排序，让找番这件事变得简单直接，不再被杂乱信息淹没。' },
  { icon: 'ri-sparkling-2-line', title: '认真的内容推荐', desc: '每一部推荐都经过编辑整理，简介与标签一目了然，帮你快速判断是否合胃口。' },
  { icon: 'ri-newspaper-line', title: '及时的动态资讯', desc: '新番消息、行业观察与幕后故事，第一时间为你梳理成易读的资讯内容。' },
];

const contacts = [
  { icon: 'ri-mail-line', label: '内容合作', value: 'hello@yaojing-anime.demo' },
  { icon: 'ri-customer-service-2-line', label: '意见反馈', value: 'support@yaojing-anime.demo' },
  { icon: 'ri-map-pin-line', label: '办公地点', value: '示例市 · 二次元创意园区 A 座' },
];

const socials = [
  { icon: 'ri-weibo-fill', label: '微博', href: 'https://zgsmwlw.cn' },
  { icon: 'ri-bilibili-fill', label: '哔哩哔哩', href: 'https://www.bilibili.com' },
  { icon: 'ri-douban-fill', label: '豆瓣', href: 'https://www.douban.com' },
  { icon: 'ri-youtube-fill', label: 'YouTube', href: 'https://www.youtube.com' },
];

export default function About() {
  useSeo(
    '关于我们 - 妖精动漫',
    '了解妖精动漫的定位、服务理念与联系方式。我们致力于为动漫爱好者提供清爽好用的动漫资源推荐与资讯门户。',
    '关于妖精动漫,动漫资源门户,动漫资讯,联系我们',
  );

  return (
    <div className="w-full">
      <PageHero
        title="关于我们"
        subtitle="做一个动漫爱好者愿意常来的内容门户。"
        crumbs={[{ label: '首页', to: '/' }, { label: '关于我们' }]}
      />

      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <section className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-10 items-start">
          <div className="lg:col-span-2">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">我们是谁</h2>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-8">
              妖精动漫是一个专注动漫内容展示与资讯发布的门户站点，面向广大动漫爱好者，尤其是关注日本动漫、国产动漫与热门作品的年轻群体和二次元文化粉丝。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-8">
              我们希望解决一个很实际的问题：作品太多、信息太杂，想找一部合心意的番往往要翻很久。于是我们把作品整理成清晰的分类与标签，配上多维筛选和推荐机制，让你用更少的时间，找到更对味的内容。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-8">
              除了作品本身，我们也关心行业的动态。新番消息、制作幕后、市场观察，都会以易读的资讯形式呈现出来，让你在追番之外，也能了解动画世界的更多面。
            </p>
          </div>

          <aside className="rounded-lg bg-primary-50 border border-primary-100 p-6">
            <h3 className="text-base font-bold text-foreground-950">网站信息</h3>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-center justify-between">
                <span className="text-foreground-500">站点名称</span>
                <span className="font-medium text-foreground-900">妖精动漫</span>
              </li>
              <li className="flex items-center justify-between">
                <span className="text-foreground-500">内容定位</span>
                <span className="font-medium text-foreground-900">动漫资源 + 资讯</span>
              </li>
              <li className="flex items-center justify-between">
                <span className="text-foreground-500">上线年份</span>
                <span className="font-medium text-foreground-900">2026</span>
              </li>
              <li className="flex items-center justify-between">
                <span className="text-foreground-500">服务状态</span>
                <span className="inline-flex items-center gap-1 text-accent-600 font-medium"><i className="ri-checkbox-blank-circle-fill text-[6px]"></i>演示站点</span>
              </li>
            </ul>
          </aside>
        </section>

        <section className="mt-12 md:mt-16">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-6">我们的理念</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            {values.map((v) => (
              <div key={v.title} className="rounded-lg bg-background-50 border border-background-200 p-6">
                <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                  <i className={`${v.icon} text-2xl`}></i>
                </span>
                <h3 className="text-base font-semibold text-foreground-950">{v.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-12 md:mt-16 grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-10">
          <div className="lg:col-span-2">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-6">联系我们</h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              {contacts.map((c) => (
                <div key={c.label} className="rounded-lg bg-background-100 p-5">
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-50 text-primary-600 mb-3">
                    <i className={`${c.icon} text-xl`}></i>
                  </span>
                  <p className="text-xs text-foreground-400">{c.label}</p>
                  <p className="mt-1 text-sm font-medium text-foreground-900 break-all">{c.value}</p>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-6">关注我们</h2>
            <div className="rounded-lg bg-background-50 border border-background-200 p-5">
              <div className="flex flex-wrap gap-3">
                {socials.map((s) => (
                  <a
                    key={s.label}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={s.label}
                    className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    <i className={`${s.icon} text-xl`}></i>
                  </a>
                ))}
              </div>
              <p className="mt-4 text-xs text-foreground-400 leading-relaxed">
                以上为示例社交入口，点击将跳转至对应平台的公开页面。
              </p>
            </div>
          </div>
        </section>

        <section className="mt-12 md:mt-16 rounded-lg bg-primary-600 p-6 md:p-8 text-center">
          <h2 className="text-xl md:text-2xl font-bold text-background-50">开始你的追番之旅</h2>
          <p className="mt-3 text-sm md:text-base text-background-200 max-w-xl mx-auto">从分类页开始，用多维筛选找到属于你的下一部心动之作。</p>
          <div className="mt-5 flex flex-wrap justify-center gap-3">
            <Link to="/category" className="inline-flex items-center gap-1.5 h-11 px-6 rounded-md bg-background-50 text-primary-700 text-sm font-semibold hover:bg-accent-500 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
              浏览动漫分类<i className="ri-arrow-right-line"></i>
            </Link>
            <Link to="/news" className="inline-flex items-center gap-1.5 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-400 transition-colors whitespace-nowrap cursor-pointer">
              查看最新资讯
            </Link>
          </div>
        </section>

        <p className="mt-10 text-xs text-foreground-400 leading-relaxed">
          版权声明：本站内容均为演示用途，作品名称、简介、评分与资讯均为示例数据，不代表任何真实作品或机构。若涉及相关权益，请联系我们进行处理。
        </p>
      </div>
    </div>
  );
}